/**
 *
 * @param item html element
 * @returns transform values
 */
const getTranslate = (item: HTMLElement): number[] | number | undefined => {
    const transArr = [];

    if (!window.getComputedStyle) {return;}
    const style = getComputedStyle(item);
    const transform = style.transform || (style as any).mozTransform || (style as any).msTransform;
    let mat = transform.match(/^matrix3d\((.+)\)$/);

    if (mat) {return parseFloat(mat[1].split(', ')[13]);}

    mat = transform.match(/^matrix\((.+)\)$/);
    mat ? transArr.push(parseFloat(mat[1].split(', ')[4])) : transArr.push(0);
    mat ? transArr.push(parseFloat(mat[1].split(', ')[5])) : transArr.push(0);

    return transArr;
}

export const getTranslateX = (item: HTMLElement): number => {
    const result = getTranslate(item);
    return Array.isArray(result) ? result[0] : 0;
}

export const getTranslateY = (item: HTMLElement): number => {
    const result = getTranslate(item);
    return Array.isArray(result) ? result[1] : 0;
}